module.exports = __webpack_public_path__ + "static/img/6.360a99e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/6.png
// module id = SGbr
// module chunks = 0